import { createTheme } from "@material-ui/core";

export const temaDaAplicacao = createTheme({
    palette: {
        primary: {
            main: '#f57c00',
            contrastText: '#fcfcfc',
        },
        secondary: {
            main: '#212121',
            contrastText: '#ffa726',
        }
    }
});
